module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_right.9b6a7849.jpg";